module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (124).8aa4e388.jpg";